import type { NextPage } from 'next';
import GivingliComponent from '@components/projects/givingli/givingli';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { ProjectProps } from '@models/project.interface';

const Givingli: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <GivingliComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default Givingli;

export { getServerSideProps } from '@layouts/project-layout/project-layout';
